import { createFileRoute, Outlet } from "@tanstack/react-router"

/**
 * `/cni/licenses/*` parent layout — sadece Outlet.
 * `_authed.cni.licenses.index.tsx` list, `_authed.cni.licenses.$id.tsx` detail.
 */
export const Route = createFileRoute("/_authed/cni/licenses")({
  component: CniLicensesLayout,
})

function CniLicensesLayout() {
  return <Outlet />
}
